/**
 * Quote delivery by email — not currently wired up.
 * The "Send Quote" button is disabled pending backend integration.
 */
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";

import Button from "components/Button";

import { useArrangement } from "./ArrangementContext";

const INPUT_CLASS =
  "w-full rounded-md border border-olive px-4 py-3 text-evergreen focus:border-evergreen focus:outline-none focus:ring-1 focus:ring-evergreen";

export default function QuoteDeliverySection() {
  const { state, setQuoteEmails } = useArrangement();
  const { quoteEmails } = state;

  const updateEmail = (index: number, value: string) => {
    const updated = [...quoteEmails];
    updated[index] = value;
    setQuoteEmails(updated);
  };

  const addEmail = () => {
    setQuoteEmails([...quoteEmails, ""]);
  };

  const removeEmail = (index: number) => {
    const updated = quoteEmails.filter((_, i) => i !== index);
    setQuoteEmails(updated.length > 0 ? updated : [""]);
  };

  return (
    <div>
      <h2 className="mb-2 text-xl font-bold text-evergreen">
        Where should we send your quote?
      </h2>
      <p className="mb-6 text-sm text-soil">
        We&apos;ll email a detailed quote based on your selections. You can add
        multiple recipients.
      </p>

      <div className="mb-6 space-y-3">
        {quoteEmails.map((email, index) => (
          <div key={index} className="flex items-center gap-2">
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => updateEmail(index, e.target.value)}
              className={INPUT_CLASS}
              placeholder="Email address"
            />
            {quoteEmails.length > 1 && (
              <button
                onClick={() => removeEmail(index)}
                className="text-soil hover:text-evergreen"
              >
                <TrashIcon className="h-5 w-5" />
              </button>
            )}
          </div>
        ))}

        <button
          onClick={addEmail}
          className="flex items-center gap-2 text-sm text-evergreen hover:underline"
        >
          <PlusIcon className="h-4 w-4" />
          Add another email
        </button>
      </div>

      <Button variant="primary" size="lg" fullWidth disabled>
        SEND QUOTE (Coming Soon)
      </Button>
    </div>
  );
}
